import { Box, Flex, Text } from '@chakra-ui/react';
import Balance from '@ui/components/Balance';
import Features, { features } from '@ui/components/Features';
import { useDefaultAppBar } from '@ui/components/MobileAppBarProvider';
import WithWallet from '@ui/components/Wallet/WithWallet';
import { COIN_MODE, useCoinMode } from '@ui/hooks/useCoinMode';
import { isFeatureEnabled } from '@ui/hooks/useIsFeatureEnabled';
import { useTranslations } from '@ui/i18n';
import getBgImage from '@ui/utils/getBgImageProps';
import React from 'react';

import useUseLcro from '../UseLcro/components/useUseLcro';
import { UseLcroCard } from './useLcroCard';
import UseLcroDirectlyPartnerCards from './UseLcroDirectlyPartnerCards';

type UseLcroDirectlyProps = {
  showTitle?: boolean;
};
function UseLcroDirectly({ showTitle }: UseLcroDirectlyProps) {
  useDefaultAppBar();

  const t = useTranslations();
  const globalCoinMode = useCoinMode();
  const coinModeInfo = COIN_MODE[globalCoinMode];
  const bgImageProps =
    globalCoinMode === 'atom'
      ? getBgImage('PATTERN_2_ATOM')
      : globalCoinMode === 'eth'
      ? getBgImage('PATTERN_STAKE_ETH')
      : getBgImage('PATTERN_1');
  const { liquidBalanceUsd, liquidBalance } = useUseLcro();

  return (
    <>
      <Box position="relative" flexGrow={1} bgPos="left 90px" {...bgImageProps}>
        <WithWallet
          mt={8}
          mb="22px"
          px="16px"
          actionHint={t('see your {coin} balance', {
            coin: coinModeInfo.liquidName,
          })}
        >
          <Text
            hidden={!showTitle || isFeatureEnabled(features.Atom)}
            textStyle="h4Bold"
            color="text-active"
            textAlign="center"
          >
            {t('Use {coin}', {
              coin: coinModeInfo.liquidName,
            })}
          </Text>
          <Balance
            className="veno-tour__use-coin-balance"
            mt="24px"
            title={t(`Wallet {coin} Balance`, {
              coin: coinModeInfo.liquidName,
            })}
            amount={liquidBalance}
            unitDecimals={coinModeInfo.liquidDecimals}
            icon={<coinModeInfo.LiquidIcon />}
            usdAmount={liquidBalanceUsd}
            usdDisplayDecimals={2}
            showUsdAmount
            displayDecimals={coinModeInfo.displayDecimals}
          />
          <Flex mt={8}>
            <UseLcroDirectlyPartnerCards />
          </Flex>
          <Features.useLcroCard>
            {globalCoinMode === 'cro' || globalCoinMode === 'atom' ? (
              <UseLcroCard mt="16px" />
            ) : null}
          </Features.useLcroCard>
        </WithWallet>
      </Box>
    </>
  );
}

export default UseLcroDirectly;
